import React, { useState, useEffect } from 'react';
import '../pages/AdminDashboard.css';

const VistaProductos = () => {
  const [productos, setProductos] = useState([]);
  const [cargando, setCargando] = useState(true);
  
  // Estados para manejar el Modal y el Formulario
  const [modalAbierto, setModalAbierto] = useState(false);
  const [productoEditando, setProductoEditando] = useState(null); // null = Crear Nuevo, objeto = Editar
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    precio_base_kg: '',
    imagen_url: ''
  });
  
  // --- ESTADOS PARA FORMATOS ---
  const [modalFormatosAbierto, setModalFormatosAbierto] = useState(false);
  const [productoParaFormatos, setProductoParaFormatos] = useState(null);
  const [presentaciones, setPresentaciones] = useState([]);
  const [nuevoFormato, setNuevoFormato] = useState({ formato: '', peso_estimado_kg: '' });

  const urlBaseAPI = 'https://api.pascolo.com.ar/api/admin/productos';

  // Cargar productos al inicio
  const fetchProductos = async () => {
    setCargando(true);
    try {
      const respuesta = await fetch(urlBaseAPI);
      const data = await respuesta.json();
      
      // --- NUEVO BLINDAJE ---
      if (Array.isArray(data)) {
        setProductos(data);
      } else {
        console.error("El backend devolvió algo que no es un array:", data);
        setProductos([]); // Forzamos un array vacío para que no explote el .map()
      }
      
    } catch (error) {
      console.error("Error al cargar productos:", error);
      setProductos([]); // Si el fetch falla (ej. servidor caído), no rompe la pantalla
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    fetchProductos();
  }, []);

  // Manejadores del Formulario y Modal
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const abrirModalNuevo = () => {
    setProductoEditando(null);
    setFormData({ nombre: '', descripcion: '', precio_base_kg: '', imagen_url: '' });
    setModalAbierto(true);
  };

  const abrirModalEditar = (producto) => {
    setProductoEditando(producto);
    setFormData({
      nombre: producto.nombre,
      descripcion: producto.descripcion || '',
      precio_base_kg: producto.precio_base_kg,
      imagen_url: producto.imagen_url || ''
    });
    setModalAbierto(true);
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setProductoEditando(null);
  };

  const abrirModalFormatos = async (producto) => {
    setProductoParaFormatos(producto);
    setModalFormatosAbierto(true);
    cargarPresentaciones(producto.id);
  };

  const cargarPresentaciones = async (productoId) => {
    try {
      const res = await fetch(`https://api.pascolo.com.ar/api/admin/productos/${productoId}/presentaciones`);
      const data = await res.json();
      setPresentaciones(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error al cargar presentaciones");
    }
  };

  const handleAgregarFormato = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`https://api.pascolo.com.ar/api/admin/productos/${productoParaFormatos.id}/presentaciones`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(nuevoFormato)
      });
      if (res.ok) {
        setNuevoFormato({ formato: '', peso_estimado_kg: '' });
        cargarPresentaciones(productoParaFormatos.id); // Recarga la mini-tabla
      }
    } catch (error) {
      console.error("Error al guardar formato", error);
    }
  };

  const handleEliminarFormato = async (idPresentacion) => {
    if (!window.confirm("¿Quitar este formato?")) return;
    try {
      const res = await fetch(`https://api.pascolo.com.ar/api/admin/presentaciones/${idPresentacion}`, { method: 'DELETE' });
      if (res.ok) {
        cargarPresentaciones(productoParaFormatos.id);
      } else {
        const data = await res.json();
        alert(data.error || "No se pudo eliminar.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Enviar el formulario (POST o PUT)
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const esEdicion = productoEditando !== null;
    const url = esEdicion ? `${urlBaseAPI}/${productoEditando.id}` : urlBaseAPI;
    const metodo = esEdicion ? 'PUT' : 'POST';

    try {
      const respuesta = await fetch(url, {
        method: metodo,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (respuesta.ok) {
        cerrarModal();
        fetchProductos(); // Recargar la tabla
      } else {
        alert("Hubo un error al guardar el producto.");
      }
    } catch (error) {
      console.error("Error al guardar:", error);
    }
  };

  const formatearPrecio = (precio) => {
    return `$ ${Number(precio).toLocaleString('es-AR')}`;
  };

  if (cargando) return <p>Cargando productos...</p>;

  return (
    <div className="vista-productos">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2>Gestión de Productos</h2>
        <button 
          onClick={abrirModalNuevo}
          style={{ backgroundColor: '#2d5a27', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}
        >
          + Agregar Producto
        </button>
      </div>
      
      <div className="tabla-container" style={{ overflowX: 'auto', backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
          <thead>
            <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #ddd' }}>
              <th style={{ padding: '15px', width: '60px' }}>Foto</th>
              <th style={{ padding: '15px' }}>ID</th>
              <th style={{ padding: '15px' }}>Nombre</th>
              <th style={{ padding: '15px' }}>Precio Base / Kg</th>
              <th style={{ padding: '15px', textAlign: 'center' }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {productos.map((producto) => (
              <tr 
                key={producto.id} 
                style={{ 
                  borderBottom: '1px solid #eee',
                  // Si está inactivo, le bajamos la opacidad a la fila para que se note archivado
                  opacity: producto.activo ? 1 : 0.6,
                  backgroundColor: producto.activo ? 'white' : '#f8f9fa'
                }}
              >
                <td style={{ padding: '15px' }}>
                  <img 
                    src={producto.imagen_url || '/placeholder.jpg'} 
                    alt={producto.nombre} 
                    style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #ccc' }}
                  />
                </td>
                <td style={{ padding: '15px', fontWeight: 'bold' }}>#{producto.id}</td>
                <td style={{ padding: '15px', fontWeight: 'bold' }}>
                  {producto.nombre} 
                  {/* Una etiqueta rápida para identificarlo visualmente */}
                  {!producto.activo && <span style={{ marginLeft: '10px', fontSize: '11px', backgroundColor: '#dc3545', color: 'white', padding: '2px 6px', borderRadius: '4px' }}>INACTIVO</span>}
                </td>
                <td style={{ padding: '15px', color: '#2d5a27', fontWeight: 'bold' }}>
                  {formatearPrecio(producto.precio_base_kg)}
                </td>
                <td style={{ padding: '15px', textAlign: 'center', display: 'flex', gap: '8px', justifyContent: 'center' }}>
                  <button 
                    onClick={() => abrirModalFormatos(producto)}
                    style={{ background: '#ff9800', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
                  >
                    Formatos
                  </button>
                  <button 
                    onClick={() => abrirModalEditar(producto)}
                    style={{ background: '#009ee3', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
                  >
                    Editar
                  </button>
                  
                  {/* RENDERIZADO CONDICIONAL DEL BOTÓN QUITAR */}
                  {producto.activo ? (
                    <button 
                      onClick={async () => {
                        const confirmar = window.confirm(`¿Querés quitar a ${producto.nombre} del catálogo público? No afectará pedidos ni lotes viejos.`);
                        if (!confirmar) return;
                        
                        try {
                          const res = await fetch(`https://api.pascolo.com.ar/api/admin/productos/${producto.id}`, {
                            method: 'DELETE'
                          });
                          if (res.ok) {
                            fetchProductos();
                          } else {
                            alert("No se pudo ocultar el producto.");
                          }
                        } catch (error) {
                          console.error(error);
                        }
                      }}
                      style={{ background: '#f44336', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
                    >
                      Quitar
                    </button>
                  ) : (
                    /* --- NUEVO BOTÓN PARA VOLVER A ACTIVAR --- */
                    <button 
                      onClick={async () => {
                        const confirmar = window.confirm(`¿Querés volver a activar a ${producto.nombre} en el catálogo público?`);
                        if (!confirmar) return;
                        
                        try {
                          const res = await fetch(`https://api.pascolo.com.ar/api/admin/productos/${producto.id}/reactivar`, {
                            method: 'PUT'
                          });
                          if (res.ok) {
                            fetchProductos(); // Recarga la lista completa
                          } else {
                            alert("No se pudo reactivar el producto.");
                          }
                        } catch (error) {
                          console.error(error);
                        }
                      }}
                      style={{ background: '#2d5a27', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
                    >
                      Reactivar
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* --- MODAL FORMULARIO --- */}
      {modalAbierto && (
        <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
          <div className="modal-card" style={{ backgroundColor: 'white', padding: '30px', borderRadius: '10px', width: '500px', maxWidth: '90%', boxShadow: '0 4px 15px rgba(0,0,0,0.2)' }}>
            <h3 style={{ marginTop: 0, borderBottom: '2px solid #2d5a27', paddingBottom: '10px', color: '#333' }}>
              {productoEditando ? 'Editar Producto' : 'Nuevo Producto'}
            </h3>
            
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '20px' }}>
              
              <div>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px', fontSize: '14px' }}>Nombre</label>
                <input type="text" name="nombre" value={formData.nombre} onChange={handleInputChange} required style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box' }} />
              </div>

              <div>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px', fontSize: '14px' }}>Precio Base por Kg ($)</label>
                <input type="number" step="0.01" name="precio_base_kg" value={formData.precio_base_kg} onChange={handleInputChange} required style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box' }} />
              </div>

              <div>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px', fontSize: '14px' }}>Descripción</label>
                <textarea name="descripcion" value={formData.descripcion} onChange={handleInputChange} rows="3" style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box', resize: 'vertical' }} />
              </div>

              <div>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px', fontSize: '14px' }}>
                  Imagen del Producto
                </label>
                
                <div style={{ display: 'flex', gap: '15px', alignItems: 'center', backgroundColor: '#f8f9fa', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}>
                  {/* Vista previa miniatura de lo que se va cargando */}
                  <img 
                    src={formData.imagen_url || '/placeholder.jpg'} 
                    alt="Vista previa" 
                    style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #ddd', backgroundColor: '#fff' }}
                  />
                  
                  <div style={{ flex: 1 }}>
                    <input 
                      type="file" 
                      accept="image/*"
                      onChange={async (e) => {
                        const file = e.target.files[0];
                        if (!file) return;

                        // FormData es obligatorio para transmitir archivos binarios
                        const fileData = new FormData();
                        fileData.append('imagen', file);

                        try {
                          // Subimos el archivo directo al endpoint que creamos recién
                          const respuesta = await fetch('https://api.pascolo.com.ar/api/admin/productos/upload-imagen', {
                            method: 'POST',
                            body: fileData // No lleva Headers de Content-Type, el navegador lo pone solo
                          });

                          if (respuesta.ok) {
                            const data = await respuesta.json();
                            // Guardamos la URL generada en el estado del formulario
                            setFormData({ ...formData, imagen_url: data.imagen_url });
                          } else {
                            alert("Error al subir la imagen al servidor.");
                          }
                        } catch (error) {
                          console.error("Error en la carga:", error);
                          alert("Error de conexión al subir la imagen.");
                        }
                      }}
                      style={{ fontSize: '13px' }}
                    />
                    <p style={{ margin: '5px 0 0 0', fontSize: '11px', color: '#666' }}>Soportados: JPG, PNG, WEBP.</p>
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                <button type="submit" style={{ flex: 1, padding: '12px', backgroundColor: '#2d5a27', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>
                  Guardar
                </button>
                <button type="button" onClick={cerrarModal} style={{ flex: 1, padding: '12px', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>
                  Cancelar
                </button>
              </div>

            </form>
          </div>
        </div>
      )}
      {modalFormatosAbierto && (
        <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
          <div className="modal-card" style={{ backgroundColor: 'white', padding: '30px', borderRadius: '10px', width: '500px', maxWidth: '90%', boxShadow: '0 4px 15px rgba(0,0,0,0.2)' }}>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '2px solid #ff9800', paddingBottom: '10px', marginBottom: '15px' }}>
              <h3 style={{ margin: 0, color: '#333' }}>Formatos: {productoParaFormatos?.nombre}</h3>
              <button onClick={() => setModalFormatosAbierto(false)} style={{ background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer' }}>❌</button>
            </div>

            {/* Listado de Formatos Actuales */}
            <div style={{ maxHeight: '200px', overflowY: 'auto', marginBottom: '20px' }}>
              {presentaciones.length === 0 ? (
                <p style={{ color: '#666', fontSize: '14px', fontStyle: 'italic' }}>No hay formatos asignados a este producto.</p>
              ) : (
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {presentaciones.map(pres => (
                    <li key={pres.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', borderBottom: '1px solid #eee', fontSize: '14px' }}>
                      <span><strong>{pres.formato}</strong> <span style={{ color: '#666' }}>({pres.peso_estimado_kg} kg)</span></span>
                      <button onClick={() => handleEliminarFormato(pres.id)} style={{ background: '#f44336', color: 'white', border: 'none', padding: '4px 8px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>
                        Quitar
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* Formulario para agregar nuevo */}
            <form onSubmit={handleAgregarFormato} style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '6px', border: '1px solid #ddd' }}>
              <h4 style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#555' }}>Añadir nuevo formato</h4>
              <div style={{ display: 'flex', gap: '10px' }}>
                <input 
                  type="text" 
                  placeholder="Ej: Media horma" 
                  value={nuevoFormato.formato} 
                  onChange={(e) => setNuevoFormato({...nuevoFormato, formato: e.target.value})} 
                  required 
                  style={{ flex: 2, padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }} 
                />
                <input 
                  type="number" 
                  step="0.001" 
                  placeholder="Peso en Kg (Ej: 0.500)" 
                  value={nuevoFormato.peso_estimado_kg} 
                  onChange={(e) => setNuevoFormato({...nuevoFormato, peso_estimado_kg: e.target.value})} 
                  required 
                  style={{ flex: 1.5, padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }} 
                />
                <button type="submit" style={{ background: '#2d5a27', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
                  Añadir
                </button>
              </div>
            </form>

          </div>
        </div>
      )}
    </div>
  );
};

export default VistaProductos;